import styled from 'styled-components';

export const DragPriorityCell = styled.div`
  display: grid;
  grid-template-columns: auto 24px 24px;
  align-items: center;
  column-gap: 2px;
  color: ${({ theme }) => theme.headerColor};

  .anticon {
    color: ${({ theme }) => theme.headerColor};
  }
`;

export const DragHandle = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
`;

export const DragPriorityButtonSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  .ant-btn {
    border: none;
    background: transparent;
    box-shadow: none;
    width: 24px;
    height: 24px;
    padding: 0;

    &:hover,
    &:focus {
      background: transparent !important;
      border: none !important;
    }
  }
`;
